import Administration from './Administration';
import AdministrationUnderline from './AdministrationUnderline';
import AppleStore from './AppleStore';
import BasketUnderline from './BasketUnderline';
import Bed from './Bed';
import BedUnderline from './BedUnderline';
import Briefcase from './Briefcase';
import Buildings from './Buildings';
import Calendar from './Calendar';
import CalendarUnderline from './CalendarUnderline';
import CarUnderline from './CarUnderline';
import Cell from './Cell';
import CheckmarkCyan from './CheckmarkCyan';
import ConversationUnderline from './ConversationUnderline';
import Disk from './Disk';
import Dress from './Dress';
import Earth from './Earth';
import EarthBlueUnderline from './EarthBlueUnderline';
import EarthUnderline from './EarthUnderline';
import EuroCurrency from './EuroCurrency';
import EuroCurrencyUnderline from './EuroCurrencyUnderline';
import FactoryUnderline from './FactoryUnderline';
import ForkliftUnderline from './ForkliftUnderline';
import GooglePlay from './GooglePlay';
import GraphBlueUnderline from './GraphBlueUnderline';
import GraphPurpleUnderline from './GraphPurpleUnderline';
import Hammer from './Hammer';
import HammerUnderline from './HammerUnderline';
import Handheart from './Handheart';
import HandheartPinkUnderline from './HandheartPinkUnderline';
import HandheartUnderline from './HandheartUnderline';
import HealthCaseUnderline from './HealthCaseUnderline';
import Healthcare from './Healthcare';
import Heart from './Heart';
import HeartHandCare from './HeartHandCareUnderline';
import HourGlass from './HourGlass';
import HourGlassRedUnderline from './HourGlassRedUnderline';
import HourGlassUnderline from './HourGlassUnderline';
import HouseUnderline from './HouseUnderline';
import Logistic from './Logistic';
import Mask from './Mask';
import Meeting from './Meeting';
import MentalHealthUnderline from './MentalHealthUnderline';
import Monitor from './Monitor';
import MonitorUnderline from './MonitorUnderline';
import MouseClick from './MouseClick';
import MouseClickUnderline from './MouseClickUnderline';
import Network from './Network';
import NetworkBeigeUnderline from './NetworkBeigeUnderline';
import NetworkUnderline from './NetworkUnderline';
import Notebook from './Notebook';
import Pen from './Pen';
import PenUnderline from './PenUnderline';
import Phone from './Phone';
import PhoneUnderline from './PhoneUnderline';
import PlateUnderline from './PlateUnderline';
import Rocket from './Rocket';
import RocketYellowUnderline from './RocketYellowUnderline';
import Selfie from './Selfie';
import SelfieHumanUnderline from './SelfieHumanUnderline';
import SelfieUnderline from './SelfieUnderline';
import Share from './Share';
import StarUnderline from './StarUnderline';
import StarYellowUnderline from './StarYellowUnderline';
import Statistics from './Statistics';
import StatisticsUnderline from './StatisticsUnderline';
import SteeringWheelUnderline from './SteeringWheelUnderline';
import TodoUnderline from './TodoUnderline';
import TruckUnderline from './TruckUnderline';
import WatchUnderline from './WatchUnderline';
import WineGlassUnderline from './WineGlassUnderline';

export {
	Administration,
	AdministrationUnderline,
	AppleStore,
	BasketUnderline,
	BedUnderline,
	Bed,
	NetworkBeigeUnderline,
	GraphBlueUnderline,
	GraphPurpleUnderline,
	Briefcase,
	Buildings,
	CalendarUnderline,
	Calendar,
	CarUnderline,
	Cell,
	CheckmarkCyan,
	Disk,
	Dress,
	Earth,
	EarthBlueUnderline,
	EarthUnderline,
	EuroCurrencyUnderline,
	EuroCurrency,
	FactoryUnderline,
	ForkliftUnderline,
	GooglePlay,
	Hammer,
	HammerUnderline,
	Handheart,
	HandheartUnderline,
	HealthCaseUnderline,
	Healthcare,
	Heart,
	HeartHandCare,
	HourGlassUnderline,
	HourGlassRedUnderline,
	HourGlass,
	HouseUnderline,
	Logistic,
	Mask,
	Meeting,
	MentalHealthUnderline,
	MonitorUnderline,
	Monitor,
	MouseClick,
	MouseClickUnderline,
	NetworkUnderline,
	Network,
	Notebook,
	Pen,
	PenUnderline,
	Phone,
	PhoneUnderline,
	HandheartPinkUnderline,
	PlateUnderline,
	Rocket,
	RocketYellowUnderline,
	SelfieUnderline,
	SelfieHumanUnderline,
	Selfie,
	Share,
	StarUnderline,
	StarYellowUnderline,
	Statistics,
	StatisticsUnderline,
	SteeringWheelUnderline,
	ConversationUnderline,
	TodoUnderline,
	TruckUnderline,
	WatchUnderline,
	WineGlassUnderline,
};

export const List = {
	Administration,
	AdministrationUnderline,
	AppleStore,
	BasketUnderline,
	Bed,
	BedUnderline,
	Briefcase,
	Buildings,
	Calendar,
	CalendarUnderline,
	CarUnderline,
	Cell,
	CheckmarkCyan,
	ConversationUnderline,
	Disk,
	Dress,
	Earth,
	EarthBlueUnderline,
	EarthUnderline,
	EuroCurrency,
	EuroCurrencyUnderline,
	FactoryUnderline,
	ForkliftUnderline,
	GooglePlay,
	GraphBlueUnderline,
	GraphPurpleUnderline,
	HammerUnderline,
	Handheart,
	HandheartPinkUnderline,
	HandheartUnderline,
	HealthCaseUnderline,
	Healthcare,
	Heart,
	HeartHandCare,
	HourGlass,
	HourGlassRedUnderline,
	HourGlassUnderline,
	HouseUnderline,
	Logistic,
	Mask,
	Meeting,
	MentalHealthUnderline,
	Monitor,
	MonitorUnderline,
	MouseClick,
	MouseClickUnderline,
	Network,
	NetworkBeigeUnderline,
	NetworkUnderline,
	Notebook,
	Pen,
	PenUnderline,
	Phone,
	PhoneUnderline,
	PlateUnderline,
	Rocket,
	RocketYellowUnderline,
	Selfie,
	SelfieHumanUnderline,
	SelfieUnderline,
	Share,
	StarUnderline,
	StarYellowUnderline,
	Statistics,
	StatisticsUnderline,
	SteeringWheelUnderline,
	TodoUnderline,
	TruckUnderline,
	WatchUnderline,
	WineGlassUnderline,
};

/*
 * `no-shadow` reports every member of this enum against the import of the same name at the top of the
 * file. Enum members are reached as `ICONS.X` and cannot collide with a binding, so these are false
 * positives; the rule stays on everywhere else.
 */
/* eslint-disable @typescript-eslint/no-shadow */
export enum ICONS {
	Administration = 'Administration',
	AdministrationUnderline = 'AdministrationUnderline',
	AppleStore = 'AppleStore',
	BasketUnderline = 'BasketUnderline',
	BedUnderline = 'BedUnderline',
	Bed = 'Bed',
	NetworkBeigeUnderline = 'NetworkBeigeUnderline',
	GraphBlueUnderline = 'GraphBlueUnderline',
	GraphPurpleUnderline = 'GraphPurpleUnderline',
	Briefcase = 'Briefcase',
	Buildings = 'Buildings',
	Calendar = 'Calendar',
	CalendarUnderline = 'CalendarUnderline',
	CarUnderline = 'CarUnderline',
	Cell = 'Cell',
	CheckmarkCyan = 'CheckmarkCyan',
	Disk = 'Disk',
	Dress = 'Dress',
	Earth = 'Earth',
	EarthBlueUnderline = 'EarthBlueUnderline',
	EarthUnderline = 'EarthUnderline',
	EuroCurrency = 'EuroCurrency',
	FactoryUnderline = 'FactoryUnderline',
	ForkliftUnderline = 'ForkliftUnderline',
	GooglePlay = 'GooglePlay',
	Hammer = 'Hammer',
	HammerUnderline = 'HammerUnderline',
	Handheart = 'Handheart',
	HandheartUnderline = 'HandheartUnderline',
	HealthCaseUnderline = 'HealthCaseUnderline',
	Healthcare = 'Healthcare',
	Heart = 'Heart',
	HeartHandCare = 'HeartHandCare',
	HourGlassUnderline = 'HourGlassUnderline',
	HourGlassRedUnderline = 'HourGlassRedUnderline',
	HourGlass = 'HourGlass',
	HouseUnderline = 'HouseUnderline',
	LightbulbLarge = 'LightbulbLarge',
	Logistic = 'Logistic',
	Mask = 'Mask',
	Meeting = 'Meeting',
	MentalHealthUnderline = 'MentalHealthUnderline',
	EuroCurrencyUnderline = 'EuroCurrencyUnderline',
	MonitorUnderline = 'MonitorUnderline',
	Monitor = 'Monitor',
	MouseClick = 'MouseClick',
	MouseClickUnderline = 'MouseClickUnderline',
	NetworkUnderline = 'NetworkUnderline',
	Network = 'Network',
	Notebook = 'Notebook',
	Pen = 'Pen',
	Phone = 'Phone',
	PenUnderline = 'PenUnderline',
	HandheartPinkUnderline = 'HandheartPinkUnderline',
	PlateUnderline = 'PlateUnderline',
	Rocket = 'Rocket',
	RocketYellowUnderline = 'RocketYellowUnderline',
	SelfieUnderline = 'SelfieUnderline',
	SelfieHumanUnderline = 'SelfieHumanUnderline',
	Selfie = 'Selfie',
	Share = 'Share',
	StarUnderline = 'StarUnderline',
	StarYellowUnderline = 'StarYellowUnderline',
	Statistics = 'Statistics',
	StatisticsUnderline = 'StatisticsUnderline',
	SteeringWheelUnderline = 'SteeringWheelUnderline',
	ConversationUnderline = 'ConversationUnderline',
	TodoUnderline = 'TodoUnderline',
	TruckUnderline = 'TruckUnderline',
	WatchUnderline = 'WatchUnderline',
	WineGlassUnderline = 'WineGlassUnderline',
}
